import { useEffect, useRef, useState } from 'react'
import { Form, Select, Radio, Button, Upload, message } from 'antd'
import { FileAddOutlined, FileDoneOutlined } from '@ant-design/icons'
import { YhFormBox } from '@/components/YhFormBoxVertical'
import { FormItemTypeEnum, IYhFormBox, IYhFormItemsBox, IYhFormRef } from '@/components/YhFormBox/Types'
import useGlobalModel from '@/model/globalModel'
import { YHModal } from '@/components/YHModal'
import { baseModel } from '../model'
import { globalPrompt } from '@/components/message'
import { Service } from '../service'
import { getBaseImgLookUrl, getBaseImgUploadUrl, getBaseUploadData } from '@/utils/constants'
import moment from 'moment'

import './style.scss'

export const EditModal = () => {
    const { editVisible, setEditVisible, mode, loadData, driverList, setDriverList, needReceiptList } = baseModel()
    const [checkUserType, setCheckUserType] = useState<string>('')
    const [checkUserList, setCheckUserList] = useState<any>([])
    const [checkUserValue, setCheckUserValue] = useState<string[]>([])
    const [documentList, setDocumentList] = useState<any[]>([])
    const formRef = useRef<IYhFormRef>()
    const disabledDate = (current: any) => {
        return current && current < new Date()
    }

    const {
        user: { createUser },
    } = useGlobalModel(({ user }) => [user])

    useEffect(() => {
        if (editVisible.visible && mode === 'edit') {
            getDetails().then(() => {})
        } else {
            setCheckUserType('')
            setCheckUserList([])
            setCheckUserValue([])
            setDocumentList([])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editVisible.visible])

    useEffect(() => {
        if (driverList?.length > 0) {
            const uniqueFleet: any[] = []
            const fleetSet = new Set(driverList.map((item: any) => item.fleet))
            fleetSet.forEach((value) => {
                uniqueFleet.push(value)
            })
            setCheckUserList(uniqueFleet)
        }
    }, [driverList])

    const getDetails = async () => {
        let response = await Service.one(editVisible.value.id)
        response.retData.startTime = moment(response.retData.startTime)
        response.retData.endTime = moment(response.retData.endTime)
        response.retData.documentList = []
        if (response.retData.driverInformationList && response.retData.driverInformationList.length > 0) {
            let _announcementUser: string[] = []
            let _announcementUserList: { userId: string }[] = []
            let _type: string[] = []
            let _fleet: string[] = []
            response.retData.driverInformationList.forEach((item: any) => {
                _announcementUser.push(item.id)
                _announcementUserList.push({ userId: item.id })
                if (_type.length === 0 || _type[0] !== item.type) {
                    _type.push(item.type)
                }
                if (_fleet.length === 0 || _fleet[0] !== item.fleet) {
                    _fleet.push(item.fleet)
                }
            })

            if (response.retData.driverInformationList.length === driverList.length) {
                setCheckUserType('全部')
            }
            response.retData.announcementUser = _announcementUser
            response.retData.announcementUserList = _announcementUserList
            setCheckUserValue(response.retData.announcementUser)
        }
        if (response.retData.onlineAnnouncementDetailsList && response.retData.onlineAnnouncementDetailsList.length > 0) {
            response.retData.onlineAnnouncementDetailsList.forEach((item: any) => {
                if (item.documentPath) {
                    response.retData.documentList.push({
                        uid: item.documentPath,
                        status: 'done',
                        name: item.documentPath,
                        response: {
                            retData: item.documentPath,
                        },
                    })
                }
            })
            setDocumentList(response.retData.documentList)
        }
        formRef.current?.setFieldsValue({ ...response.retData })
    }

    const onOk = () => {
        formRef.current?.validateFields().then(async (val) => {
            let _data = JSON.parse(JSON.stringify(val))

            if (mode === 'edit') {
                _data.id = editVisible.value.id
            }
            _data.createUser = createUser
            _data.startTime = moment(val.startTime).format('YYYY-MM-DD HH:mm')
            _data.endTime = moment(val.endTime).format('YYYY-MM-DD HH:mm')
            _data.onlineAnnouncementDetailsList = []
            if (checkUserValue?.length > 0) {
                _data.announcementUserList = checkUserValue.map((item: string) => {
                    return {
                        userId: item,
                    }
                })
            }

            if (documentList && documentList?.length > 0) {
                _data.onlineAnnouncementDetailsList = documentList.map((item: any) => ({ documentPath: item?.response?.retData }))
            }

            try {
                let setData: any
                if (mode === 'add') {
                    setData = Service.insert
                }
                if (mode === 'edit') {
                    setData = Service.edit
                }
                let response = await setData(_data)
                if (response.retCode === 200) {
                    setEditVisible({ visible: false, value: {} })
                    message.success(mode === 'add' ? '添加成功！' : mode === 'edit' ? '编辑成功！' : '')
                    await loadData()
                }
            } catch (error) {
                await message.warning(error)
            }
        })
    }
    const handleChangeUserSelect = (val: string[]) => {
        const updatedDriverList = driverList.map((item: { value: string; isChecked: boolean }) => {
            if (val.includes(item.value)) {
                return { ...item, isChecked: true }
            } else {
                return { ...item, isChecked: false }
            }
        })
        setDriverList(updatedDriverList)
        formRef.current?.setFieldsValue({ announcementUser: val })
        setCheckUserValue(val)
    }
    const handleCheckUserType = (event: any) => {
        let value = event.target.value
        let selectedValues: string[] = []
        const updatedDriverList = driverList.map((item: any) => {
            let isChecked = false
            if (value === '全部') {
                isChecked = true
                selectedValues.push(item.value)
            } else if (value === '司机' || value === '押运员') {
                if (item.type === value) {
                    isChecked = true
                    selectedValues.push(item.value)
                }
            } else {
                if (item.fleet === value) {
                    isChecked = true
                    selectedValues.push(item.value)
                }
            }
            return { ...item, isChecked }
        })
        setCheckUserType(value)
        setDriverList(updatedDriverList)
        formRef.current?.setFieldsValue({ announcementUser: selectedValues })
        setCheckUserValue(selectedValues)
    }

    const onPreview = (file: any) => {
        let url = file?.response?.retData
        if (url) {
            window.open(getBaseImgLookUrl(url))
        }
    }
    const handleUploadChange = async (e: any) => {
        setDocumentList(e.fileList)

        if (e?.file.status === 'done') {
            if (e?.file?.response?.retCode === 0) {
                let _list = e.fileList.filter((item: any) => item.status === 'done')
                setDocumentList(_list)
            } else {
                await message.error('文件上传失败，请重新上传!')
            }
        }
        return { ...e, fileList: documentList }
    }

    //保留缓存及回显表单
    const saveCache = (val: { [key: string]: any }) => {
        formRef.current?.setFieldsValue(val)
    }

    const formItem: IYhFormItemsBox = {
        title: '',
        style: { padding: '10px', marginBottom: '10px' },
        items: [
            {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: '开始时间',
                fieldName: 'startTime',
                format: 'YYYY-MM-DD HH:mm',
                showTime: true,
                disabledDate,
                span: 24,
                rules: [{ required: true, message: '请选择开始时间' }],
            },
            {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: '结束时间',
                fieldName: 'endTime',
                format: 'YYYY-MM-DD HH:mm',
                showTime: true,
                disabledDate,
                span: 24,
                rules: [{ required: true, message: '请选择结束时间' }],
            },
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: '对象',
                fieldName: 'announcementUser',
                span: 24,
                formItem: (
                    <Form.Item name="announcementUser" label="对象" rules={[{ required: true, message: '请选择对象' }]}>
                        <div>
                            <Select
                                mode="multiple"
                                value={checkUserValue}
                                showSearch
                                options={driverList}
                                filterOption={(input: string, option: any) => {
                                    return option?.label.toLowerCase().includes(input.toLowerCase())
                                }}
                                placeholder="对象"
                                onChange={handleChangeUserSelect}
                            />
                            <Radio.Group value={checkUserType} onChange={handleCheckUserType}>
                                <Radio.Button value="全部">全部</Radio.Button>
                                <Radio.Button value="司机">司机</Radio.Button>
                                <Radio.Button value="押运员">押运员</Radio.Button>
                                {checkUserList.map((item: any, index: number) => {
                                    return (
                                        <Radio.Button key={index} value={item}>
                                            {item || '-'}
                                        </Radio.Button>
                                    )
                                })}
                            </Radio.Group>
                        </div>
                    </Form.Item>
                ),
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '是否回执',
                fieldName: 'needReceipt',
                options: needReceiptList.map((item: any) => ({ label: item, value: item })),
                span: 24,
                rules: [{ required: true, message: '请选择是否回执' }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '主题',
                fieldName: 'title',
                span: 24,
                rules: [{ required: true, message: '请填写主题' }],
            },
            {
                type: FormItemTypeEnum.TextArea,
                fieldLabel: '内容',
                fieldName: 'content',
                span: 24,
                rules: [{ required: true, message: '请填写内容' }],
            },
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: '文档',
                fieldName: 'document',
                span: 24,
                formItem: (
                    <Form.Item name="documentList" label="上传附件" valuePropName="documentList">
                        <Upload
                            name="file"
                            action={getBaseImgUploadUrl()}
                            data={getBaseUploadData()}
                            onChange={(e) => handleUploadChange(e)}
                            listType="picture"
                            fileList={documentList}
                            iconRender={(file) => {
                                return (
                                    <FileDoneOutlined
                                        onClick={() => {
                                            onPreview(file)
                                        }}
                                    />
                                )
                            }}
                        >
                            <Button icon={<FileAddOutlined />}>选择附件上传</Button>
                        </Upload>
                    </Form.Item>
                ),
            },
        ],
    }

    const onChange = (changedValues: { [key: string]: any }) => {
        saveCache(changedValues)
    }

    const FromConfig: IYhFormBox = {
        formRef,
        labelAlign: 'right',
        onChange,
        boxs: [formItem],
    }

    const onClose = () => {
        globalPrompt('modal', {
            title: mode === 'add' ? '新增' : mode === 'edit' ? '编辑' : '查看',
            type: 'warning',
            text: mode === 'add' ? '您还有正在新增的记录...是否关闭？' : mode === 'edit' ? '您还有正在编辑的记录...是否关闭？' : '是否关闭？',
            okText: '关闭页面',
            onOk: () => setEditVisible({ visible: false, value: {} }),
            cancelText: mode === 'add' ? '继续添加' : mode === 'edit' ? '继续编辑' : '继续查看',
            onCancel: () => {
                return
            },
        })
    }

    return (
        <YHModal
            visible={editVisible.visible}
            title={mode === 'add' ? '您正在添加...' : mode === 'edit' ? '您正在编辑...' : '您正在查看...'}
            cancelText={mode === 'add' ? '取消添加' : mode === 'edit' ? '取消编辑' : '取消'}
            okText={mode === 'add' ? '确定添加' : mode === 'edit' ? '确定编辑' : '确定'}
            onCancel={onClose}
            onOk={onOk}
            width={700}
            showFooter={true}
        >
            <YhFormBox {...FromConfig} isShowHeader={false} />
        </YHModal>
    )
}
